'use client';

import { useCookieConsent } from '@/lib/hooks/useCookieConsent';
import { Cookie } from 'lucide-react';

export default function CookieSettingsButton() {
  const { resetConsent } = useCookieConsent();

  return (
    <button
      onClick={resetConsent}
      className="text-slate-500 hover:text-amber-500 transition-colors flex items-center gap-1.5"
    >
      <Cookie className="w-3.5 h-3.5" />
      Cookies
    </button>
  );
}

